import { render } from "./intro-message-edit.vue?vue&type=template&id=512a484a&lang=pug"
import script from "./intro-message-edit.vue?vue&type=script&lang=js"
export * from "./intro-message-edit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__